import { PaginationStateProps } from 'common/state/types';
import {
  Account,
  AccountBalance,
  AccountCustomer,
  AccountMovement,
  AccountOperating,
  AccountOwed,
  AccountWithBalance,
  Xrates,
} from './actions';

// #region Account
export interface UserAccountsState extends PaginationStateProps {
  pending: boolean;
  accounts: Account[] | null;
  error?: string;
}

export const defaultUserAccountsState: UserAccountsState = {
  pending: false,
  accounts: null,
  count: 0,
  next: null,
  previous: null,
  error: null,
};

export interface AccountsState extends PaginationStateProps {
  pending: boolean;
  accounts: Account[] | null;
  error?: string;
}

export const defaultAccountsState: UserAccountsState = {
  pending: false,
  accounts: null,
  count: 0,
  next: null,
  previous: null,
  error: null,
};
// #endregion

// #region AccountBalance
export interface UserAccountBalancesState extends PaginationStateProps {
  pending: boolean;
  balances: AccountBalance[] | null;
  error?: string;
}

export const defaultUserAccountBalancesState: UserAccountBalancesState = {
  pending: false,
  balances: null,
  count: 0,
  next: null,
  previous: null,
  error: null,
};
// #endregion

// #region AccountWithBalance
export interface UserAccountsWithBalanceState extends PaginationStateProps {
  pending: boolean;
  accounts: AccountWithBalance[] | null;
  error?: string;
}

export const defaultUserAccountsWithBalanceState: UserAccountsWithBalanceState =
  {
    pending: false,
    accounts: null,
    count: 0,
    next: null,
    previous: null,
    error: null,
  };
// #endregion

// #region AccountOperating
export interface AccountOperatingsState {
  pending: boolean;
  operatings: AccountOperating[] | null;
  error?: string;
}

export const defaultAccountOperatingsState: AccountOperatingsState = {
  pending: false,
  operatings: null,
  error: null,
};
// #endregion

// #region AccountOwed
export interface AccountOwedsState {
  pending: boolean;
  oweds: AccountOwed[] | null;
  error?: string;
}

export const defaultAccountOwedsState: AccountOwedsState = {
  pending: false,
  oweds: null,
  error: null,
};
// #endregion

// #region Xrate
export interface XratesState {
  pending: boolean;
  xrates: Xrates | null;
  error?: string;
}

export const defaultXratesState: XratesState = {
  pending: false,
  xrates: null,
  error: null,
};
// #endregion

// #region AccountBalance
export interface AccountCustomersState {
  pending: boolean;
  customers: AccountCustomer[] | null;
  error?: string;
}

export const defaultAccountCustomersState: AccountCustomersState = {
  pending: false,
  customers: null,
  error: null,
};
// #endregion

// #region AccountMovement
export interface AccountMovementsState extends PaginationStateProps {
  pending: boolean;
  movements: AccountMovement[] | null;
  error?: string;
}

export const defaultAccountMovementsState: AccountMovementsState = {
  pending: false,
  movements: null,
  count: 0,
  next: null,
  previous: null,
  error: null,
};
// #endregion
